export default function initStatCounters() {
    const blocks = document.querySelectorAll('.block-impact_stats_block');
    if (!blocks.length) return;

    if (!('IntersectionObserver' in window)) {
        blocks.forEach((block) => animateStats(block));
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            animateStats(entry.target);
        });
    }, { threshold: 0.3 });

    blocks.forEach((block) => observer.observe(block));
}

function animateStats(block) {
    if (block.dataset.statsAnimated === 'true') return;
    block.dataset.statsAnimated = 'true';

    const numbers = block.querySelectorAll('.stat-number');
    numbers.forEach((el) => {
        const raw = el.dataset.statTarget || el.textContent.trim();
        el.dataset.statTarget = raw;
        const { value, prefix, suffix } = parseStatValue(raw);

        if (value === null) return;

        const duration = 1600;
        const startTime = performance.now();
        const format = (num) => prefix + num.toLocaleString() + suffix;

        el.textContent = format(0);

        requestAnimationFrame(function step(now) {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = Math.round(eased * value);

            el.textContent = format(current);

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.textContent = format(value);
            }
        });

        // Guarantee we never remain at 0 if animation frames are throttled.
        window.setTimeout(() => {
            el.textContent = format(value);
        }, duration + 250);
    });
}

function parseStatValue(raw) {
    const match = raw.match(/^([^\d]*?)([\d,]+(?:\.\d+)?)(.*?)$/);
    if (!match) return { value: null, prefix: '', suffix: '' };

    const prefix = match[1];
    const value = parseFloat(match[2].replace(/,/g, ''));
    const suffix = match[3];

    return { value, prefix, suffix };
}
